import { Link } from "react-router-dom"
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Button } from "./ui/button"
import AppLayout from "./AppLayout"
import { Calendar, CheckCircle, Clock, List, MapPin, User, Wallet } from "lucide-react"
import authService from "../Services/authService";
import subscribeUserToPush from "../Services/NotificationService";
import { getFCMToken, onMessageListener } from "../Services/firebase";
import { Bell } from "lucide-react";
import { useNotification } from "../Services/NotificationContext";



const DashboardScreen = () => {
  const [count, setCount] = useState({});
  const [upcomingaptmts, setUpcomingaptmts] = useState([]);
  //const [notificationCount, setNotificationCount] = useState(2);
  const { notificationCount } = useNotification();


  useEffect(() => {
    loadAppointments();
  }, []);

  // useEffect(() => {
  //   getFCMToken().then(token => {
  //     console.log("FCM Token:", token);
  //     // Optional: Send this token to Laravel backend
  //     fetch(authService.getApiUrl() + "save-fcm-token", {
  //       method: "POST",
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json; charset=UTF-8',
  //         Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
  //       },
  //       body: JSON.stringify({
  //         token: token,
  //         user_id: authService.getCurrentuser().id,
  //       })
  //     })
  //   });

  //   onMessageListener().then(payload => {
  //     console.log("Received in foreground:", payload);
  //     alert(`${payload.notification.title} - ${payload.notification.body}`);
  //   });
  // }, []);


  // useEffect(() => {
  //   if ('serviceWorker' in navigator && 'PushManager' in window) {
  //     Notification.requestPermission().then((permission) => {
  //       if (permission === 'granted') {
  //         subscribeUserToPush();
  //       } else {
  //         console.warn("Notification permission denied");
  //       }
  //     });
  //   }
  // }, []);

  const loadAppointments = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + "phlebloappointment");

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        assign_to: authService.getCurrentuser().id,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        if (result && result.data) {
          setCount(result.data);
        }
        setUpcomingaptmts(result.upcoming);
      })
      .catch((err) => {
        console.error("Failed to load dashboard count:", err.message);
      });
  };

  const formatTime12Hour = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour);
    const suffix = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${minute} ${suffix}`;
  };


  return (
    <AppLayout>
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-1 min-w-0">
            <div className="relative h-[100px] w-[100px] mr-3 flex-shrink-0">
              <Link to="/" className="flex items-center">
                <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
              </Link>
            </div>
            <div className="min-w-0 flex-1 mr-10">
              <h1 className="text-xl font-bold text-gray-800 truncate">Dashboard</h1>
              <p className="text-sm text-gray-500 truncate">Welcome back, {count.deliveryagentname?.user_name}</p>
            </div>
          </div>
          {/* <Button size="icon" asChild className="border-gray-300 text-gray-600 flex-shrink-0 ml-2 w-fit h-auto">
            <Link to="/notifications">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pranaam-red opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pranaam-red"></span>
              </span>
              <span className="sr-only">Notifications</span>
            </Link>

          </Button> */}
          <Button
            size="icon"
            asChild
            className="relative border-gray-300 text-yellow-400 flex-shrink-0 ml-2 w-10 h-10 bg-transparent hover:bg-gray-100/10"
          >
            <Link to="/notifications">
              <Bell className="w-5 h-5 text-yellow-400" />
              <span className="absolute -top-1 -right-1 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                {notificationCount ?? 0}
              </span>
              <span className="sr-only">Notifications</span>
            </Link>
          </Button>




        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-3">
          <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Today's Appointments</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <Calendar className="h-4 w-4 text-pranaam-red mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count.totalappointments}</span>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Pending Collections</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <Clock className="h-4 w-4 text-amber-500 mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count.pendingorders}</span>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Completed Today</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 text-green-600 mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count.todaycompletedorders}</span>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Completed Orders</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <User className="h-4 w-4 text-pranaam-red mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count.overalcompletedorders}</span>
              </div>
            </CardContent>
          </Card>

          {/* <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Due Amount</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <Wallet className="h-4 w-4 text-pranaam-red mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count.total_due_amount}</span>
              </div>
            </CardContent>
          </Card> */}

          <Card className="border-gray-200">
            <CardHeader className="p-3 pb-2">
              <CardTitle className="text-xs font-medium text-gray-500 leading-tight text-left">Total Earnings</CardTitle>
            </CardHeader>
            <CardContent className="p-3 pt-0">
              <div className="flex items-center">
                <Wallet className="h-4 w-4 text-pranaam-red mr-2 flex-shrink-0" />
                <span className="text-xl font-bold text-gray-800">{count?.phleblo_payment?.total_weekly_due_amount}</span>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div className="space-y-3">
          <h2 className="text-lg font-semibold text-gray-800 ml-1 text-left">Quick Actions</h2>
          <div className="grid grid-cols-2 gap-2">
            <Button
              asChild
              className="h-12 text-sm justify-start bg-white hover:bg-gray-50 text-gray-800 border-gray-200 p-3"
              variant="outline"
            >
              <Link to="/appointments" className="flex items-center w-full">
                <List className="mr-2 h-4 w-4 text-pranaam-red flex-shrink-0" />
                <span className="truncate text-left">Appointments</span>
              </Link>
            </Button>

            <Button
              asChild
              className="h-12 text-sm justify-start bg-white hover:bg-gray-50 text-gray-800 border-gray-200 p-3"
              variant="outline"
            >
              <Link to="/attendance" className="flex items-center w-full">
                <Clock className="mr-2 h-4 w-4 text-pranaam-red flex-shrink-0" />
                <span className="truncate text-left">Attendance</span>
              </Link>
            </Button>

            {/* <Button
              asChild
              className="h-12 text-sm justify-start bg-white hover:bg-gray-50 text-gray-800 border-gray-200 p-3"
              variant="outline"
            >
              <Link to="/navigate" className="flex items-center w-full">
                <MapPin className="mr-2 h-4 w-4 text-pranaam-red flex-shrink-0" />
                <span className="truncate text-left">Navigate</span>
              </Link>
            </Button> */}

            {/* <Button
              asChild
              className="h-12 text-sm justify-start bg-white hover:bg-gray-50 text-gray-800 border-gray-200 p-3"
              variant="outline"
            >
              <Link to="/handover-amount" className="flex items-center w-full">
                <Wallet className="mr-2 h-4 w-4 text-pranaam-red flex-shrink-0" />
                <span className="truncate text-left">Handover Amount</span>
              </Link>
            </Button> */}

            <Button
              asChild
              className="h-12 text-sm justify-start bg-white hover:bg-gray-50 text-gray-800 border-gray-200 p-3"
              variant="outline"
            >
              <Link to="/profile" className="flex items-center w-full">
                <User className="mr-2 h-4 w-4 text-pranaam-red flex-shrink-0" />
                <span className="truncate text-left">Profile</span>
              </Link>
            </Button>
          </div>
        </div>

        {/* Upcoming Appointments */}
        <div className="space-y-3">
          <div className="flex items-center justify-between ml-1">
            <h2 className="text-lg font-semibold text-gray-800">Upcoming</h2>
            <Button variant="link" asChild className="text-pranaam-red p-0 h-auto mr-1">
              <Link to="/appointments" state={{ defaultTab: "upcoming" }}>View All</Link>
            </Button>
          </div>

          <div className="space-y-3">
            {upcomingaptmts.map((appointment, index) => (
              <Card key={index} className="overflow-hidden border-gray-200">
                <Link to={`/appointments/${appointment.order_id}`}>
                  <div className="p-3">
                    <div className="flex justify-between items-start mb-2">
                      <div className="flex-1 min-w-0 mr-2 text-left">
                        <h3 className="font-medium text-gray-800 truncate">{appointment?.orders_items?.familyMembers || "Patient"}</h3>
                        <p className="text-sm text-gray-500 line-clamp-1">{appointment?.orders_items?.test_name || "Test Info"}</p>
                      </div>
                      <span className="px-2 py-1 text-xs font-medium rounded-full bg-pranaam-red text-white flex-shrink-0">
                        {appointment.slot_date} {formatTime12Hour(appointment.slot_time)}
                      </span>
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <MapPin className="h-3 w-3 mr-1 flex-shrink-0" />
                      <span className="truncate"> {appointment.building_name},{appointment.area},
                        {appointment.landmark},{appointment.pincode}</span>
                    </div>
                  </div>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default DashboardScreen
